import { api } from "../api";

export const deletePatient = async (id: string): Promise<void> => {
  await api.services.patient.deletePatient(id);
};
